import React from 'react'
import styled from 'styled-components'

import { t } from 'src/lib/i18n-react'
import { Flex, Box, Text, Button } from '@chatterbug/aaron'

type Props = {
  login: string
  isCurrentUser: boolean
  aboutMe: any
}

const AboutMe: React.FC<Props> = ({ login, isCurrentUser, aboutMe }) => {
  const { cooked, url } = aboutMe
  if (!cooked) {
    return null
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width={{ _: '100%', mobile: 'auto' }}
    >
      <Flex alignSelf="flex-start" mb="2x">
        <Text variant="text.h5" as="h5">
          {t('About Me')}
        </Text>
      </Flex>
      <SC.DiscoursePost dangerouslySetInnerHTML={{ __html: cooked }} />

      <Box mt="2x" width="100%">
        {isCurrentUser && (
          <Flex justifyContent="center">
            <Button
              onClick={() => {
                window.location = url
              }}
            >
              {t('Edit your introduction')}
            </Button>
          </Flex>
        )}
        {!isCurrentUser && (
          <a href={url}>{t('Say hello to %{login} here', { login }) + ' →'}</a>
        )}
      </Box>
    </Flex>
  )
}
const SC: any = {}
SC.DiscoursePost = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .meta {
    display: none;
  }

  /* onebox is the classname of the video wrapper */
  .lightbox-wrapper,
  .onebox,
  ul,
  p {
    width: 100%;
  }

  .lightbox-wrapper,
  .onebox {
    @media (min-width: 420px) {
      width: 66%;
    }
  }

  h2 {
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 1.2;
    color: rgba(10, 10, 10, 1);
    align-self: flex-start;
    font-family: sofia-pro;
  }

  video {
    border-radius: 8px;
    height: auto;
    width: 100%;
  }

  img {
    border-radius: 8px;
    height: auto;
    width: 100%;
  }

  img.emoji {
    width: 20px;
    height: 20px;
    margin-bottom: 5px;
  }
`

export default AboutMe
